var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5464 0.914062C10.7573 1.14844 10.7573 1.5 10.5464 1.71094L4.35889 7.89844C4.12451 8.13281 3.77295 8.13281 3.56201 7.89844L0.374512 4.71094C0.140137 4.5 0.140137 4.14844 0.374512 3.9375C0.585449 3.70312 0.937012 3.70312 1.14795 3.9375L3.93701 6.72656L9.74951 0.914062C9.96045 0.703125 10.312 0.703125 10.5229 0.914062H10.5464Z",
    fill: "#00587B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.49b3376ff816aed13b8a97b2455ee5a7.svg";
export { ForwardRef as ReactComponent };